import { create } from 'zustand';
import { getDefaultLang, LangEnum } from '../helpers/lang';

interface Store {
  language: LangEnum;
  setLanguage: (languages: LangEnum) => void;
}

export const useInputLangStore = create<Store>((set) => ({
  language: getDefaultLang(),
  setLanguage: (language) => {
    set({ language });
  },
}));
